import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type DatadogConnectorConfig = typeof DatadogConnector._.Config;

export const DatadogConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Datadog,
  logoPath: 'images/datadog-logo.svg',
  categories: [IntegrationConnectorCategory.Monitoring],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.ApiKey,
      configSchema: z.object({
        baseUrl: z.url(),
      }),
      encryptedConfigSchema: z.object({
        apiKey: z.string().min(1),
        appKey: z.string().min(1),
      }),
    }),
  ]),
});
